import { GETSEARCH } from '../constants/actionTypes';

const searchReducer = (search = [], action) => {
    switch (action.type) {
        case GETSEARCH:
            return action.payload;
        default:
            return search;
    }
};

export default searchReducer;
